import { GridProps } from "@mui/material";
import { Grid6 } from "../../platform-style";
import { forwardRef } from "react";

interface LegacyGridProps extends GridProps {
  xs?: any;
  sm?: any;
  md?: any;
  lg?: any;
  xl?: any;
  xsOffset?: any;
  smOffset?: any;
  mdOffset?: any;
  lgOffset?: any;
  xlOffset?: any;
}

/**
 * @deprecated Use Grid2 instead.
 */
export const Grid = forwardRef(function (props: LegacyGridProps, ref) {
  return (
    // @ts-ignore
    <Grid6
      {...props}
      size={{ xs: props.xs, sm: props.sm, md: props.md, lg: props.lg, xl: props.xl }}
      offset={{
        xs: props.xsOffset,
        sm: props.smOffset,
        md: props.mdOffset,
        lg: props.lgOffset,
        xl: props.xlOffset,
      }}
      ref={ref}
    >
      {props.children}
    </Grid6>
  );
});
